var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"show-more"},[(_vm.hasCars)?_c('base-button',{nativeOn:{"click":function($event){return _vm.showMoreCars($event)}}},[_vm._v(_vm._s(_vm.$t("search.show-more", { leftCarsCount: _vm.getCarsLeftCount })))]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }